export default __webpack_public_path__ + "static/media/PLU-UK.0bebb99f.png";